import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WalletService } from '../services/wallet.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.scss']
})
export class CmsComponent implements OnInit {
  aepsCWForm: FormGroup;
  lat;
  lng;
  zoom;

  constructor(private formBuilder:FormBuilder, private auth: WalletService,private ngx: NgxUiLoaderService,    private toast: ToastrService,
  ) {
    this.aepsCWForm = this.formBuilder.group({
      mobile_no: ['', Validators.required],   
      amountTowithdrawl: ['', [Validators.required]],
    });
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 16;
       
      });
    }
   }

  ngOnInit(): void {
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  submit(){
    this.ngx.start();

    if(this.aepsCWForm.invalid){
      this.aepsCWForm.markAllAsTouched()
    }else{
      this.auth
      .createCMS(
        this.aepsCWForm.value,
        this.lat,
        this.lng
      )
      .subscribe(
        (res: any) => {
          console.log(res)
          this.ngx.stop();
          this.aepsCWForm.reset('')
              const secondURL = `${res.url}?data=${res.data}&skey=${res.skey}`;
      window.open(secondURL, '_blank');

          // this.toast.success(res.msg);
          // this.requestMoney.reset();

        },
        (err) => {
          this.ngx.stop();
          this.toast.error(err.error.message);
        }
      );
    }
  }
 
}
